<template>
    <div v-touch:swipe="swipeHandler" id="perStudioContainer">
        <app-appointment
        v-for="appointment in appointmentPerStudio"
        :key="appointment.title"
        :appointment="appointment"
        :studioChanged="appointmentPerStudio"></app-appointment>


        <div class="swipe-handler"></div>
    </div>

</template>
<script>
import Appointment from "./Single";
export default {
  props: ['appointmentPerStudio'],
  components: {
    appAppointment: Appointment,
  },
  methods:{
    swipeHandler(direction){
      this.$emit("swipeSelectedStudio",direction);
    }
  }
};
</script>
<style scoped>
#perStudioContainer{
  position: relative;
}
.swipe-handler{
  position: relative;
  width: 100%;
  height: 100%;
  /* pointer-events: none; */
}
</style>
